import React from "react";
import logo_arrow from "~/assets/Ico_Arrow_Small.svg";
import "../MainPage.css";

export const AdditionallyCardComponent = ({cards = []}) => {
    const handleButtonClick = (onClickFunction, event) => {
        event.preventDefault();
        if (onClickFunction && typeof onClickFunction === 'function') {
            onClickFunction();
        }
    };

    return (
        <ul className="main-page-card-additionally">
            {cards.map((card, index) => (
                <li key={index} className={"main-page-card-additionally-li"}>
                    <div
                        className="main-page-card-additionally-text-container"
                        onClick={(e) => handleButtonClick(card.primaryButtonAction, e)}
                    >
                        <img
                            src={card.imageSrc}
                            alt={card.imageAlt}
                            className={"logo-map"}
                        />
                        <div className={"main-page-card-additionally-text"}>
                            <h3>{card.title}</h3>
                            <p>{card.description}</p>
                        </div>
                        <img
                            src={logo_arrow}
                            alt={'arrow'}
                            className={"logo-arrow"}
                        />
                    </div>
                </li>
            ))}
        </ul>
    );
};